import { Button } from '@zoom/react-ui'
import classnames from 'classnames'
import './Categories.css'

function Category({ active, children, onClick, ...props }) {
  const className = classnames('Category', active && 'active')

  return (
    <div className={className} onClick={onClick}>
      <Button type="tertiary" className="Category__button" {...props}>
        {children}
      </Button>
    </div>
  )
}

function Categories({ categories, active, setActive }) {
  return (
    <div className="Categories">
      {Object.keys(categories).map((category) => (
        <Category
          key={category}
          active={active === categories[category]}
          onClick={() => setActive(categories[category])}
        >
          {category}
        </Category>
      ))}
    </div>
  )
}

export default Categories
